import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Grid, CircularProgress } from '@material-ui/core'
import { getUsers } from "../../actions/login";
import Navigation from "../../navigation/Navigation";
import axios from 'axios';

/**
 * This page presents the user with a list of all shortlisted projects by lecturers so that they can browse what each project is.
 * @returns a list of all the users shortlisted projects
 */

function ViewShortlist() {

    const [allProjects, setProjects] = useState([]);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getUsers());
        if(allProjects.length === 0) {
            getAllProjects();
        }
    }, [dispatch, allProjects]);

    /**
     * axios is used to fetch all of the lecturer projects from the database and then setProjects is set to the response of the axios request
     */
    const getAllProjects = () => {
        axios.get('https://project-allocation-schedule.herokuapp.com/lecturerProject').then(function (response) {
            setProjects(response.data)
        })
        .catch(function (error) {
            console.log(error);
        })
        .then(function () {
        });
    }

    /**
     * 
     * @param {*} id 
     * @returns 
     */
    const getProject = (id) => {
        let projectName = "";
        console.log(projectName)
        if(allProjects.length > 0) {
            allProjects.forEach(element => {
                console.log(element._id, id)
                if(element._id === id) {
                    projectName = element.title
                }
            });
        }
        return projectName;
    }

    const getDes = (id) => {
        let projectDes = "";
        if(allProjects.length > 0) {
            allProjects.forEach(element => {
                if(element._id === id) {
                    projectDes = element.description
                }
            });
        }
        return projectDes;
    }

    let users = []
    const response = useSelector((state) => state.projects.data);
    if (response){
        users = Array.from(response);
    }

    return(
        <div className="shortlistContainer">
            <Navigation/>
            <h1>Shortlisted Projects</h1>
            {!users.length ? <CircularProgress /> : (
                <Grid>
                    {users.map((user) => {
                        if(user._id === localStorage.getItem("id")) {
                            if(user.shortlist.length > 0) {
                                return (
                                    user.shortlist.map((u) => {
                                        return (
                                            <Grid className="paper" key={user._id} item>
                                                <p>{getProject(u) || u}</p>
                                                <p>{getDes(u) || u}</p>
                                            </Grid>
                                        )
                                    })
                                )
                            } else {
                                return (
                                    <Grid className="paper" key={user._id} item>
                                        <p>No shortlist</p>
                                    </Grid>
                                )
                            }
                        }
                    })}
                </Grid>
            )}
        </div>
    )
}

export default ViewShortlist